import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Product } from 'src/typings';

import { ProductService } from '../product.service';

@Component({
  selector: 'app-add-image',
  templateUrl: './add-image.component.html',
  styleUrls: ['./add-image.component.scss']
})
export class AddImageComponent {
  @Input() set product(product: Product | undefined) {
    this._product = product;
  }

  get product() {
    return this._product;
  }

  private _product: Product | undefined;

  @Output() doneEvent: EventEmitter<Product[]> = new EventEmitter();

  imageFormControl = new UntypedFormControl();

  constructor(private productService: ProductService) {}

  addImage() {
    if (!this.product) return;
    this.productService
      .addImage({
        productId: this.product.id,
        url: this.imageFormControl.value
      })
      .then((products) => {
        this.doneEvent.emit([products[0]]);
      });
  }
}
